import { differenceWith, filter, map } from 'lodash';
import { useMemo } from 'react';

import useGetFamilies from '../../../hooks/useGetFamilies';
import useGetProjects from '../../../screens/ProjectListScreen/context/hooks/useGetProjects';
import useGetCharacteristicsByFamilyId from './useGetCharacteristicsByFamilyId';
import useGetIdCardsEquipmentList from './useGetIdCardsEquipmentList';

const getFamilyOptionsFromEntities = (families) => {
  let options = [{value:'', label:'   '}];
  map(families || [], (family) => options.push(({value: family.id, label: `${family.code} ${family.name}`})));
  return options;
};

const getProjectOptionsFromEntities = (projects) => {
  let options = [{value:'', label:'   '}];
  map(projects, (project) => options.push(({value: project.id, label: `${project.number} - ${project.name}`})));
  return options;
};

const getCharacteristicsOptionsFromEntities = (characteristics) =>
  map(filter(characteristics, {type: 'NUMERIC'}), (characteristic) => ({
    value: characteristic.name,
    label: characteristic.name,
  }));

const getEquipmentListOptionsFromEntities = (equipmentList) =>
  map(equipmentList, (equipmentId) => ({
    value: equipmentId,
    label: equipmentId,
  }));

export default function useDropdownOptions({ familyId, filterOptions }) {
  const { families, isLoading: areFamiliesLoading } = useGetFamilies();
  const { projects, isLoading: areProjectsLoading } = useGetProjects();
  const { equipmentList, isLoading: isEquipmentListLoading } = useGetIdCardsEquipmentList();

  const { characteristics, isLoading: areCharacteristicsLoading } = useGetCharacteristicsByFamilyId(familyId);

  const familiesOptions = useMemo(() => getFamilyOptionsFromEntities(families), [families, areFamiliesLoading]);
  const projectsOptions = useMemo(() => getProjectOptionsFromEntities(projects), [projects, areProjectsLoading]);
  const characteristicsOptions = useMemo(
    () =>
      differenceWith(getCharacteristicsOptionsFromEntities(characteristics), filterOptions, (a, b) => a.value === b.id),
    [characteristics, areCharacteristicsLoading, filterOptions]
  );

  const equipmentListOptions = useMemo(
    () => getEquipmentListOptionsFromEntities(equipmentList),
    [(equipmentList, isEquipmentListLoading)]
  );

  return {
    projects: { isLoading: areProjectsLoading, options: projectsOptions, entity: projects },
    families: { isLoading: areFamiliesLoading, options: familiesOptions, entity: projects },
    characteristics: { isLoading: areCharacteristicsLoading, options: characteristicsOptions, entity: characteristics },
    equipmentList: { isLoading: isEquipmentListLoading, options: equipmentListOptions, entity: equipmentList },
  };
}
